import "./GanttEmptyState.css";

import { JSX } from "react/jsx-runtime";

import { Button } from "../../../../forms/Button";
import { GanttEmptyStateProps } from "../../models";

/** Centered empty state with a stacked-bars illustration (roadmap "almost ready"). */
export const GanttEmptyState = ({ title, subtext, action }: GanttEmptyStateProps): JSX.Element => (
  <div className="GanttEmptyState">
    <div className="GanttEmptyStateBars" aria-hidden="true">
      <span className="GanttEmptyStateBar GanttEmptyStateBar_1" />
      <span className="GanttEmptyStateBar GanttEmptyStateBar_2" />
      <span className="GanttEmptyStateBar GanttEmptyStateBar_3" />
    </div>
    <p className="GanttEmptyStateTitle">{title}</p>
    <p className="GanttEmptyStateSubtext body3">{subtext}</p>
    {action && (
      <div className="GanttEmptyStateAction">
        <Button text={action.label} variant="primary" size="small" onClick={action.onClick} />
      </div>
    )}
  </div>
);
